import React from 'react'
import { CopyOutlined } from '@ant-design/icons'

import { getShortText } from '../../PaymentAssignment/Utils/payment-assignment.helper'
import { DASH } from './helpers'
import CopyIconButton from './CopyIconButton'
import { SourceReportedWarning } from './SourceReported'
import styles from './ReviewQueue.module.scss'

/**
 * The Benefit ID cell on both queue tabs: the id shortened the way the
 * Benefits table shows it (first and last four, full id on hover), in the mono
 * reference style, with a button that copies the full value. No link — the Action
 * column already opens App Engine and jumps to the benefit. A dash, and no
 * copy button, when there is no id to show.
 *
 * `sourceReported` marks an id the payment's source record named but that we
 * did not resolve to: it gains the warning flag, and stays copyable so an
 * operator can look it up — copying hands them the file's word, it does not
 * act on it.
 */
const BenefitIdCell: React.FC<{
  benefitId: string | null
  sourceReported?: boolean
}> = ({ benefitId, sourceReported = false }) => (
  <span className={styles.cell}>
    {benefitId === null ? (
      DASH
    ) : (
      <span className={styles.refLine}>
        <span title={benefitId}>{getShortText(benefitId, 4)}</span>
        {sourceReported && <SourceReportedWarning />}
        <CopyIconButton
          value={benefitId}
          label="Copy benefit ID"
          tooltip="Copy"
          icon={<CopyOutlined />}
        />
      </span>
    )}
  </span>
)

export default BenefitIdCell
